import React, { useState, useEffect } from "react";
import { Field, Input, Text } from "@fluentui/react-components";
import { useStyles } from "./styles";
import log from "@/utils/logger";
import { diffCutoffStorageKey } from "@/taskpane/lib/common/diff";

export function Settings() {
  const styles = useStyles();
  const [cutoff, setCutoff] = useState<string>("0.4");

  useEffect(() => {
    const storedCutoff = localStorage.getItem(diffCutoffStorageKey);
    if (storedCutoff) {
      log.debug("Loading stored diff cutoff", "Settings", { cutoff: storedCutoff });
      setCutoff(storedCutoff);
    } else {
      log.debug("No stored diff cutoff found, using default", "Settings", { defaultCutoff: "0.4" });
    }
  }, []);

  const handleCutoffChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    const numValue = parseFloat(value);

    if (!isNaN(numValue) && numValue >= 0 && numValue <= 1) {
      log.debug("Saving new diff cutoff", "Settings", {
        oldCutoff: cutoff,
        newCutoff: value,
        numericValue: numValue,
      });
      setCutoff(value);
      localStorage.setItem(diffCutoffStorageKey, value);
    } else {
      log.warn("Invalid cutoff value entered", "Settings", {
        attemptedValue: value,
        numericValue: numValue,
        isNaN: isNaN(numValue),
        inRange: numValue >= 0 && numValue <= 1,
      });
    }
  };

  return (
    <div className={styles.settingsContainer}>
      <div className={styles.settingsSection}>
        <Text size={400} weight="semibold">
          Diff Algorithm Settings
        </Text>
        <Field
          label="Change ratio cutoff"
          hint="Value between 0 and 1. Lower values use word diff more often, higher values use sentence diff more often."
        >
          <Input type="number" step="0.1" min="0" max="1" value={cutoff} onChange={handleCutoffChange} />
        </Field>
      </div>
    </div>
  );
}
